import { render, staticRenderFns } from "./LaboratoryResearch.vue?vue&type=template&id=35538710"
import script from "./LaboratoryResearch.vue?vue&type=script&lang=js"
export * from "./LaboratoryResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports